var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_612_8888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49998 11.9166C3.50835 11.9166 1.08331 9.4916 1.08331 6.49998C1.08331 4.0744 2.67744 2.02148 4.87498 1.3314V2.4819C3.94381 2.86 3.17295 3.5499 2.69426 4.43358C2.21557 5.31726 2.05879 6.33981 2.25074 7.32632C2.44269 8.31282 2.97145 9.20198 3.74656 9.8417C4.52167 10.4814 5.49498 10.8319 6.49998 10.8333C7.36328 10.8333 8.20691 10.5755 8.92277 10.093C9.63863 9.61047 10.1941 8.9252 10.5181 8.12498H11.6686C10.9785 10.3225 8.92556 11.9166 6.49998 11.9166ZM11.8896 7.04165L5.95831 7.04165L5.95831 1.1104C6.13652 1.09252 6.31744 1.08331 6.49998 1.08331C9.4916 1.08331 11.9166 3.50835 11.9166 6.49998C11.9166 6.68252 11.9074 6.86344 11.8896 7.04165ZM7.04165 2.20023L7.04165 5.95831L10.7997 5.95831C10.6792 5.00368 10.2444 4.11629 9.56406 3.4359C8.88367 2.75551 7.99628 2.3208 7.04165 2.20023Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_612_8888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieWhite);
export default __webpack_public_path__ + "static/media/pieWhite.c5d9ff0b37d639092580a0138f205272.svg";
export { ForwardRef as ReactComponent };